import { render, staticRenderFns } from "./CryptoSettings.vue?vue&type=template&id=23ad3ee8&scoped=true&"
import script from "./CryptoSettings.vue?vue&type=script&lang=js&"
export * from "./CryptoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad3ee8",
  null
  
)

export default component.exports